import { Component, Input } from "@angular/core";
import { OnlineIndicatorComponent } from "../../../../../shared/components/online-indicator/online-indicator.component";
import { BackgroundRefreshIndicatorComponent } from "../../../../../shared/components/background-refresh-indicator/background-refresh-indicator.component";
import { CommonModule } from "@angular/common";
import { SkeletonModule } from "primeng/skeleton";


@Component({
  selector: "schedule-detail-header",
  imports: [OnlineIndicatorComponent, BackgroundRefreshIndicatorComponent, CommonModule, SkeletonModule],
  templateUrl: "./schedule-detail-header.component.html",
  styleUrl: "./schedule-detail-header.component.scss",
  standalone: true
})
export default class ScheduleDetailHeader {
  @Input({ required: true }) title!: string;
  @Input() subtitle: string | undefined;
  @Input() backCallback!: () => void;
  @Input() backLabel: string | undefined;
  @Input() showCloud: boolean = false;
  @Input() titleClass: string | undefined;
  @Input() bottomBorder: boolean = false;
  @Input() showBackgroundRefreshBar: boolean = true;
  @Input() isRefreshingInBackground: boolean = false;

  backToAreaPage(): void {
    if (this.backCallback) {
      this.backCallback();
    }
  }
}

